import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import SummaryCards from "../components/SummaryCards";
import { TrendChart, CategoryChart } from "../charts/Charts";
import { getSummary } from "../utils/helpers";

function ChartCard({ title, subtitle, children, theme }) {
  const dark = theme === "dark";
  return (
    <div style={{
      background: dark ? "rgba(255,255,255,0.04)" : "#ffffff",
      border: `1px solid ${dark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)"}`,
      borderRadius: 16, padding: 24,
      boxShadow: dark ? "0 4px 24px rgba(0,0,0,0.2)" : "0 4px 20px rgba(0,0,0,0.06)",
    }}>
      <div style={{ marginBottom: 20 }}>
        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: dark ? "#f1f5f9" : "#0f172a" }}>{title}</h3>
        {subtitle && <p style={{ margin: "4px 0 0", fontSize: 13, color: dark ? "#475569" : "#94a3b8" }}>{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export default function Dashboard() {
  const { state } = useApp();
  const { transactions, theme } = state;
  const { income, expense, balance } = getSummary(transactions);
  const [chartType, setChartType] = useState("area");
  const dark = theme === "dark";

  return (
    <div style={{ padding: "24px", maxWidth: 1400 }}>
      {/* Welcome */}
      <div style={{ marginBottom: 28 }}>
        <h2 style={{ margin: "0 0 4px", color: dark ? "#f1f5f9" : "#0f172a", fontSize: 22, fontWeight: 700 }}>
          Welcome back 
        </h2>
        <p style={{ margin: 0, color: dark ? "#475569" : "#94a3b8", fontSize: 14 }}>
          Here's your financial overview · {transactions.length} transactions total
        </p>
      </div>

      {/* Summary Cards */}
      <div style={{ marginBottom: 28 }}>
        <SummaryCards income={income} expense={expense} balance={balance} theme={theme} />
      </div>

      {/* Charts Row */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(420px, 1fr))", gap: 20, marginBottom: 28 }}>
        <ChartCard
          title="Income vs Expenses"
          subtitle="Monthly trend over time"
          theme={theme}
        >
          <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
            {["area", "bar"].map((t) => (
              <button key={t} onClick={() => setChartType(t)} style={{
                padding: "5px 14px", borderRadius: 20, border: "none", cursor: "pointer", fontSize: 12, fontWeight: 500,
                background: chartType === t ?
                 "rgba(99,102,241,0.2)" : "transparent",
                color: chartType === t ? "#a5b4fc" : dark ?
                 "#475569" : "#94a3b8",
                textTransform: "capitalize", transition: "all 0.2s",
              }}>{t === "area" ? "Area" : "Bar"}</button>
            ))}
          </div>
          {chartType === "area"
            ? <TrendChart transactions={transactions} theme={theme} />
            : <div>
                <style>{`.recharts-bar-rectangle { transition: opacity 0.2s; } 
                .recharts-bar-rectangle:hover { opacity: 0.8; }`}</style>
                <TrendChart transactions={transactions} theme={theme} />
              </div>
          }
        </ChartCard>

        <ChartCard
          title="Spending by Category"
          subtitle="Where your money goes"
          theme={theme}
        >
          <CategoryChart transactions={transactions} theme={theme} />
        </ChartCard>
      </div>

      {/* Quick stats */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 16 }}>
        {[
          { label: "Avg Monthly Income", value:
             `$${(income / 5).toFixed(0)}`, color: "#10b981" },
          { label: "Avg Monthly Expense",
             value: `$${(expense / 5).toFixed(0)}`, color: "#f43f5e" },
          { label: "Savings Rate", value: `${((balance / income) * 100).toFixed(1)}%`, color: "#6366f1" },
          { label: "Transactions", value: transactions.length, color: "#f59e0b" },
        ].map((s) => (
          <div key={s.label} style={{
            background: dark ? "rgba(255,255,255,0.03)" : "#fff",
            border: `1px solid ${dark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.08)"}`,
            borderRadius: 12, padding: "16px 20px",
          }}>
            <p style={{ margin: "0 0 4px", 
              fontSize: 12, color: dark ? "#475569" : "#94a3b8", 
              fontWeight: 500 }}>{s.label}</p>
            <p style={{ margin: 0, fontSize: 22, fontWeight: 700,
               color: s.color }}>{s.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
